export const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/
  return re.test(email)
}

export const copyToClipboard = (value) => {
  var tempInput = document.createElement('input')
  tempInput.value = value
  document.body.appendChild(tempInput)
  tempInput.select()
  document.execCommand('copy')
  document.body.removeChild(tempInput)
  alert('Copied URL to clipboard successfully')
}
